/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.TableSearch";
        class TableSearchWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("TableSearchWidgetTypeClass.createInstance()");
                    return new TableSearchWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("TableSearchWidgetInstanceClass._storeHtml()");
                    TableSearchWidgetInstanceClass.HtmlData = htmlData;
                    if (TableSearchWidgetInstanceClass.SaveSearchModalHtml != null) {
                        this._presentInstances();
                    }
                };
                this._storeModalHtml = (htmlData) => {
                    this._log.info("TableSearchWidgetInstanceClass._storeModalHtml()");
                    TableSearchWidgetInstanceClass.SaveSearchModalHtml = htmlData;
                    if (TableSearchWidgetInstanceClass.HtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("TableSearchWidgetTypeClass::constructor");
                if (TableSearchWidgetInstanceClass.HtmlData != null && TableSearchWidgetInstanceClass.SaveSearchModalHtml != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (TableSearchWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/TableSearch/table-search.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (TableSearchWidgetInstanceClass.SaveSearchModalHtml == null) {
                        core.Loader.getVersionedHTML('widgets/TableSearch/save-search-modal.html', this._storeModalHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.TableSearchWidgetTypeClass = TableSearchWidgetTypeClass;
        class TableSearchWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._tableHolder = null;
                this._tableHeading = null;
                this._dataTable = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._saveCsvSpan = null;
                this._revertSearchSpan = null;
                this._specialColumns = null;
                this._registerDeselection = false;
                this._reselectOnRefresh = true;
                this._lastSelectedDocument = null;
                this._documents = null;
                this._refreshTriggers = null;
                this._queryTriggers = null;
                this._saveSearchSpan = null;
                this._currentSearchDef = null;
                this._requestQueueInfo = false;
                this._respondToPublishedQuery = false;
                this._respondToPublishedHitList = false;
                this._autoSelectMode = Widgets.DocumentAutoSelectMode.NONE;
                this._autoSelectOnHomeView = false;
                this._autoSelectThisRun = false;
                this._publishDataset = 'NONE';
                // Save search  modal support
                this._saveModalInput = null;
                this._saveModalOK = null;
                this._saveModalCancel = null;
                this._saveModalCloseSpan = null;
                this._saveModalClearText = null;
                this._saveModalLoader = null;
                this._currentModalSession = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this.presentInstance = () => {
                    this._log.info("TableSearchWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = TableSearchWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    let conf = this._config;
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._tableHolder = this._container.querySelector('#tableSearchTableHolder');
                    this._showFilterSpan = this._container.querySelector('.showFilter');
                    this._hideFilterSpan = this._container.querySelector('.hideFilter');
                    this._saveCsvSpan = this._container.querySelector('#tableSearchSaveCSV');
                    this._saveSearchSpan = this._container.querySelector('#tableSearchSaveSearch');
                    this._revertSearchSpan = this._container.querySelector('#tableSearchRevertSearch');
                    let resizableElement = this._container.querySelector('.widget__size-target');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#tableSearchTitle'), 'STR_WPT_DOCUMENTS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._saveSearchSpan, 'title', 'STR_WPT_SAVE_SEARCH');
                    this._core.Helper.setElementTranslationAttribute(this._revertSearchSpan, 'title', 'STR_WPT_REVERT_QUERY');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#tableSearchLoading'), 'STR_WPT_LOADING');
                    this._showFilterSpan.addEventListener('click', this._showFilter);
                    this._hideFilterSpan.addEventListener('click', this._hideFilter);
                    this._saveSearchSpan.addEventListener('click', this._saveSearch);
                    this._revertSearchSpan.addEventListener('click', this._revertSearch);
                    this._container.querySelector('#tableSearchReload').addEventListener('click', this._doSearch);
                    if (conf.hasOwnProperty('EnableCsvDownload') && conf.EnableCsvDownload) {
                        this._core.Functions.showElement(this._saveCsvSpan);
                        this._saveCsvSpan.addEventListener('click', this._saveCsv);
                    }
                    if (conf.hasOwnProperty('RequestQueueInfo') && (conf.RequestQueueInfo != null))
                        this._requestQueueInfo = conf.RequestQueueInfo;
                    if (conf.hasOwnProperty('RespondToPublishedQuery') && conf.RespondToPublishedQuery)
                        this._respondToPublishedQuery = true;
                    if (conf.hasOwnProperty('RespondToPublishedHitList') && conf.RespondToPublishedHitList)
                        this._respondToPublishedHitList = true;
                    if (conf.hasOwnProperty('AutoSelectMode'))
                        this._autoSelectMode = Widgets.DocumentAutoSelectMode[conf.AutoSelectMode];
                    if (conf.hasOwnProperty('AutoSelectOnHomeView') && conf.AutoSelectOnHomeView)
                        this._autoSelectOnHomeView = true;
                    if (conf.hasOwnProperty('ReselectOnRefresh') && (conf.ReselectOnRefresh != null))
                        this._reselectOnRefresh = conf.ReselectOnRefresh;
                    if (conf.hasOwnProperty('PublishDatasets') && conf.PublishDatasets)
                        this._publishDataset = conf.PublishDatasets;
                    if (conf.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                        this._refreshTriggers = conf.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    if (conf.hasOwnProperty('QueryExecutionTriggers') && conf.QueryExecutionTriggers && (conf.QueryExecutionTriggers.length > 0))
                        this._queryTriggers = conf.QueryExecutionTriggers;
                    else
                        this._queryTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._queryTriggers);
                    this._queryTriggers.forEach(trigger => {
                        trigger.EventTypes = [WPTNamespace.Navigation.LayoutActivationType.QUERY_REQUESTED];
                    });
                    if (!this._core.serviceAvailable('savedsearches'))
                        this._core.Functions.hideElement(this._saveSearchSpan);
                    let maxHeightPx = null;
                    let maxHeight = window.getComputedStyle(resizableElement).maxHeight;
                    if (maxHeight != "none") {
                        // expecting max-height set in pixels
                        maxHeightPx = parseInt(maxHeight, 10);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + maxHeightPx);
                        }
                    }
                    this._dataTable = new Widgets.ComponentDataTable(this._core, this._tableHolder, this, maxHeightPx);
                    if (conf.hasOwnProperty('InitialPageSize') && (conf.InitialPageSize != null))
                        this._dataTable.PageLength = conf.InitialPageSize;
                    if (this._publishDataset == 'INITIAL')
                        this._dataTable.VisibleDataInitialisedCallback = this._fireDatasetEvent;
                    else if (this._publishDataset == 'ALL') {
                        this._dataTable.VisibleDataInitialisedCallback = this._fireDatasetEvent;
                        this._dataTable.VisibleDataFilteredCallback = this._fireDatasetEvent;
                    }
                    this._dataTable.present();
                    if (this._requestQueueInfo)
                        this._core.OBHelper.LoadQueues();
                    // If we have a dynamic title set, that implies we're going to need CQ information to set the title
                    if (conf.hasOwnProperty('DynamicTitle') && conf.DynamicTitle)
                        this._core.OBHelper.LoadCustomQueries(this._doSearch);
                    else
                        this._doSearch();
                    this._type.instanceReady(this.getHandle());
                };
                this.updateSearch = (query, original = true) => {
                    this._log.info("TableSearchWidgetInstanceClass.updateSearch()");
                    this._core.Functions.showElement(this._loader);
                    this._currentSearchDef = this._core.OBHelper.queryDefToStoredFlexSearch(query);
                    this._showHideRevert(original);
                    this._refreshSearch();
                };
                this.updateSearchWithFlex = (searchDef, original = true) => {
                    this._log.info("TableSearchWidgetInstanceClass.updateSearchWithFlex()");
                    this._core.Functions.showElement(this._loader);
                    this._currentSearchDef = searchDef;
                    this._showHideRevert(original);
                    this._refreshSearch();
                };
                this._showHideRevert = (original) => {
                    if (original)
                        this._core.Functions.hideElement(this._revertSearchSpan);
                    else {
                        if (this._config.hasOwnProperty('Query') || this._config.hasOwnProperty('FlexQuery'))
                            this._core.Functions.showElement(this._revertSearchSpan);
                        else
                            this._core.Functions.hideElement(this._revertSearchSpan);
                    }
                };
                this._updateTitle = () => {
                    this._log.info("TableSearchWidgetInstanceClass._updateTitle()");
                    // If we have a normal title, this takes precedence
                    if ((this._config.hasOwnProperty('Title')) && this._config.Title)
                        return;
                    let conf = this._config;
                    if (!conf.hasOwnProperty('DynamicTitle') || !conf.DynamicTitle)
                        return;
                    // Default setting
                    let title = conf.DynamicTitle.replace('[[QUERY_LABEL]]', 'STR_WPT_SEARCH_RESULT');
                    if ((this._currentSearchDef) && (this._currentSearchDef.Type.toLowerCase() == 'customquery')) {
                        let cqNameTerm = this._currentSearchDef.Terms.find(term => (term.Term == '>>customquery'));
                        if (cqNameTerm) {
                            let cq = this._core.OBHelper.CustomQueryMap[cqNameTerm.Value];
                            if (cq)
                                title = conf.DynamicTitle.replace('[[QUERY_LABEL]]', cq.Label);
                        }
                    }
                    this._widgets.setTitle(this._config, this._container.querySelector('#tableSearchTitle'), this._core.Context.applyAllMacros(title));
                };
                this._refreshSearch = () => {
                    this._log.info("TableSearchWidgetInstanceClass._refreshSearch()");
                    this._updateTitle();
                    let requestSearch = this._core.OBHelper.flexDefinitionToRequest(this._currentSearchDef);
                    requestSearch.ReturnQueues = this._requestQueueInfo;
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._displayResult, null, this._callErrorHandler, this._callFailedHandler);
                };
                this._doSearch = () => {
                    this._log.info("TableSearchWidgetInstanceClass._doSearch()");
                    if (this._currentSearchDef != null) {
                        this._refreshSearch();
                        return;
                    }
                    let config = this._config;
                    if (config.hasOwnProperty('Query')) {
                        this.updateSearch(config.Query);
                    }
                    else if (config.hasOwnProperty('FlexQuery')) {
                        this.updateSearchWithFlex(config.FlexQuery);
                    }
                    else {
                        console.warn("no 'Query/FlexQuery' configured for TableSearch widget");
                        this._displayResult({});
                    }
                };
                this._displayResult = (response) => {
                    this._log.info("TableSearchWidgetInstanceClass._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    let previousDocStillAvailable = false;
                    let columns = [];
                    if (!response.hasOwnProperty('DisplayColumns') || (response.DisplayColumns == null) || (response.DisplayColumns.length == 0)) {
                        // TODO - figure out how to label these properly!
                        response.DisplayColumns = [">>DocumentTitle", ">>DocumentType", ">>DocumentDate"];
                    }
                    let length = response.DisplayColumns.length;
                    for (let i = 0; i < length; i++) {
                        let column = response.DisplayColumns[i];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("TableSearch looking at column: " + column);
                        }
                        let heading = this._tableHeading[column];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("TableSearch got heading: " + JSON.stringify(heading));
                        }
                        let setting = null;
                        if (heading === undefined || !heading.hasOwnProperty('Title')) {
                            let keyType = this._core.OBHelper.KeywordTypeMap[column];
                            if (keyType)
                                setting = { Title: keyType.TranslatedName };
                            else
                                setting = { Title: column };
                        }
                        else {
                            setting = { Title: this._core.Locale.getTranslation(heading.Title) };
                        }
                        if (heading !== undefined && heading.hasOwnProperty('FilterType') && heading.FilterType) {
                            setting.FilterType = heading.FilterType;
                        }
                        else if (column == ">>DocumentType")
                            setting.FilterType = 'Select';
                        columns.push(setting);
                    }
                    // Insert a hidden column for the original document sort order to try to mitigate autoselect in the wrong place
                    columns.unshift({ Title: 'IntialOrder', FilterType: 'Text', Orderable: true, Visible: false });
                    this._autoSelectThisRun = false;
                    let rows = [];
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        // Do we need to check for autoselect?
                        let firstDoc = true;
                        if ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.FIRST) || ((this._autoSelectMode == Widgets.DocumentAutoSelectMode.SINGLE) && (response.Documents.length == 1))) {
                            if ((this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) || this._autoSelectOnHomeView) {
                                this._autoSelectThisRun = true;
                            }
                        }
                        this._documents = response.Documents;
                        let length = response.Documents.length;
                        for (let i = 0; i < length; i++) {
                            let doc = response.Documents[i];
                            // Need some special callback handing to manage previous document selection and/or autoselect support
                            let callBack = (this._autoSelectThisRun && firstDoc) ? this._autoSelectRowCreated : null;
                            if ((this._lastSelectedDocument != null) && (doc.ItemNum == this._lastSelectedDocument.ItemNum)) {
                                previousDocStillAvailable = true;
                                if (this._reselectOnRefresh)
                                    callBack = this._previousDocRowCreated;
                            }
                            let metaValues = [];
                            let rowValues = [];
                            let rowData = {
                                Values: rowValues,
                                Metadata: metaValues,
                                ClickCallback: this._rowClicked,
                                CreatedCallback: callBack
                            };
                            let metadata = {
                                Name: 'data-id',
                                Value: doc.ItemNum.toString(10)
                            };
                            metaValues.push(metadata);
                            // Insert count value - required to keep initial sort in line
                            rowValues.push({ Value: i, Display: i.toString(10), Sort: i, Filter: i.toString(10), PreventSanitising: true });
                            // Need to get each keyword and populate from the document's keyword records
                            let colCount = response.DisplayColumns.length;
                            for (let k = 0; k < colCount; k++) {
                                let columnName = response.DisplayColumns[k];
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("TableSearch looking at column: " + columnName);
                                }
                                let keyword = this._core.OBHelper.GetKeywordObject(doc, columnName, true);
                                if (!keyword)
                                    keyword = { Id: 0, Name: columnName, Type: 'AlphaNumeric', Value: '' };
                                let value = keyword.Value;
                                let cellValue = this._core.Helper.convertKeywordToDatatableCell(keyword, columns[k]);
                                let columnConf = this._specialColumns[keyword.Name];
                                if (columnConf !== undefined) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("TableSearch got special column handling for: " + keyword.Name);
                                    }
                                    this._handleSpecialColumn(value, cellValue, columnConf);
                                }
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("TableSearch adding cell value");
                                }
                                rowValues.push(cellValue);
                            }
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("TableSearch adding row data");
                            }
                            rows.push(rowData);
                            firstDoc = false;
                        }
                    }
                    else {
                        this._documents = [];
                    }
                    let tableData = {
                        Columns: columns,
                        Rows: rows
                    };
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("TableSearch requesting display from DataTables component");
                    }
                    this._dataTable.displayData(tableData);
                    if (previousDocStillAvailable)
                        this._autoSelectThisRun = false;
                    else if (this._lastSelectedDocument != null)
                        this._docDeselected();
                };
                this.returnedToHomepage = () => {
                    this._log.info("TableSearchWidgetInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                };
                this._showFilter = () => {
                    this._log.info("TableSearchWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    this._dataTable.showFilterRow();
                };
                this._hideFilter = () => {
                    this._log.info("TableSearchWidgetInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    this._dataTable.hideFilterRow();
                };
                this._autoSelectRowCreated = (rowElement) => {
                    this._log.info("TableSearchWidgetInstanceClass._autoSelectRowCreated()");
                    // Allow table build to finish before evaluating click
                    if (this._autoSelectThisRun) {
                        window.setTimeout(this._processAutoSelection.bind(this, rowElement), 0);
                    }
                };
                this._previousDocRowCreated = (rowElement) => {
                    this._log.info("TableSearchWidgetInstanceClass._previousDocRowCreated()");
                    // Allow table build to finish before evaluating click
                    window.setTimeout(this._processAutoSelection.bind(this, rowElement), 0);
                };
                this._processAutoSelection = (rowElement) => {
                    this._log.info("TableSearchWidgetInstanceClass._processAutoSelection()");
                    let event = new Event('click');
                    rowElement.dispatchEvent(event);
                    this._autoSelectThisRun = false;
                };
                this._rowClicked = (event) => {
                    this._log.info("TableSearchWidgetInstanceClass._rowClicked()");
                    // May need to loop back to self if queues not ready
                    if (this._requestQueueInfo && !this._core.OBHelper.QueuesLoaded) {
                        this._core.OBHelper.LoadQueues(this._rowClicked.bind(this, event));
                        return;
                    }
                    let config = this._config;
                    let clickedItem = event.currentTarget;
                    let docId = Number(clickedItem.getAttribute('data-id'));
                    this._lastSelectedDocument = this._documents.find(doc => doc.ItemNum == docId);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("row clicked for document: " + docId);
                    }
                    this._dataTable.clearRowSelection();
                    clickedItem.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = docId;
                    navEvent.Slots = this._activateIntoSlots;
                    if (this._requestQueueInfo) {
                        if (this._lastSelectedDocument.hasOwnProperty('Queues') && (this._lastSelectedDocument.Queues != null) && (this._lastSelectedDocument.Queues.length > 0)) {
                            let qId = this._lastSelectedDocument.Queues[0].Id;
                            navEvent.AdditionalContext["SourceQueueID"] = qId;
                            navEvent.AdditionalContext["SourceQueueRecord"] = this._core.OBHelper.Queues.find(q => q.Id == qId);
                        }
                    }
                    let targetLayoutName = "DocumentList";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._docDeselected = () => {
                    this._log.info("TableSearchWidgetInstanceClass._docDeselected()");
                    if (!this._registerDeselection)
                        return;
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED);
                    navEvent.ActivationID = this._lastSelectedDocument.ItemNum;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    navEvent.Slots = this._activateIntoSlots;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "DocumentList";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedDocument = null;
                };
                this._handleSpecialColumn = (value, cellValue, columnConf) => {
                    this._log.info("TableSearchWidgetInstanceClass._handleSpecialColumn()");
                    let showValues = false;
                    if (columnConf.hasOwnProperty('ShowValues') && columnConf.ShowValues) {
                        showValues = true;
                    }
                    let label = "&nbsp;";
                    let colour = columnConf.DefaultColour;
                    let specialCellContent = document.createElement('div');
                    specialCellContent.classList.add("special-cell");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking for value: " + value);
                    }
                    let valueSetting = columnConf.ValueOptions[value];
                    if (valueSetting !== undefined) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got special column value setting");
                        }
                        if (valueSetting.hasOwnProperty('Colour') && valueSetting.Colour) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using value colour: " + valueSetting.Colour);
                            }
                            colour = valueSetting.Colour;
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("no colour configured");
                            }
                            colour = undefined;
                        }
                        if (showValues) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("showing values");
                            }
                            if (valueSetting.hasOwnProperty('Label') && valueSetting.Label) {
                                let labelValue = this._core.Locale.getTranslation(valueSetting.Label);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("showing value label: " + labelValue);
                                }
                                cellValue.Filter = labelValue;
                                cellValue.Sort = labelValue;
                                cellValue.Value = labelValue;
                                label = this._core.Functions.safeEncodeHTMLContent(labelValue);
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("showing display value: " + cellValue.Display);
                                }
                                if (cellValue.Display != null && cellValue.Display != undefined && cellValue.Display.length > 0) {
                                    label = this._core.Functions.safeEncodeHTMLContent(cellValue.Display);
                                }
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no special column value setting, using default");
                        }
                        if (showValues) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("showing values");
                            }
                            if (columnConf.hasOwnProperty('DefaultLabel') && columnConf.DefaultLabel) {
                                let labelValue = this._core.Locale.getTranslation(columnConf.DefaultLabel);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("showing default label: " + labelValue);
                                }
                                cellValue.Filter = labelValue;
                                cellValue.Sort = labelValue;
                                cellValue.Value = labelValue;
                                label = this._core.Functions.safeEncodeHTMLContent(labelValue);
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("showing display value: " + cellValue.Display);
                                }
                                if (cellValue.Display != null && cellValue.Display != undefined && cellValue.Display.length > 0) {
                                    label = this._core.Functions.safeEncodeHTMLContent(cellValue.Display);
                                }
                            }
                        }
                    }
                    specialCellContent.innerHTML = label;
                    if (colour) {
                        specialCellContent.style.backgroundColor = colour;
                    }
                    cellValue.Display = specialCellContent.outerHTML;
                    cellValue.PreventSanitising = true;
                };
                this._saveCsv = () => {
                    this._log.info("TableSearchWidgetInstanceClass._saveCsv()");
                    this._dataTable.saveDataAsCSV();
                };
                this._callFailedHandler = (json) => {
                    this._log.info("TableSearchWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("TableSearchWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._saveSearch = () => {
                    this._log.info("TableSearchWidgetInstanceClass._saveSearch()");
                    // Set up modal placeholder
                    let modalSession = 'save-search-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentModalSession = modalSession;
                        modal.DIV.innerHTML = TableSearchWidgetInstanceClass.SaveSearchModalHtml;
                        this._saveModalInput = modal.DIV.querySelector('#saveSearchTextbox');
                        this._saveModalOK = modal.DIV.querySelector('#saveSearchOK');
                        this._saveModalCancel = modal.DIV.querySelector('#saveSearchCancel');
                        this._saveModalCloseSpan = modal.DIV.querySelector('#saveSearchDialogCloseSpan');
                        this._saveModalClearText = modal.DIV.querySelector('#saveSearchClearTextbox');
                        this._saveModalLoader = modal.DIV.querySelector('#saveSearchLoader');
                        //this._saveModalNameExists =  this._globalModalDiv.querySelector('#envelopesNameExistsBanner');
                        this._core.Helper.prepareHourglassIcon(this._saveModalLoader);
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#saveSearchDialogHeading'), 'STR_WPT_SAVE_SEARCH');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#saveSearchLabel'), 'STR_WPT_NAME');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalInput, 'placeholder', 'STR_WPT_NAME');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalInput, 'aria-label', 'STR_WPT_NAME');
                        // this._core.Helper.setElementTranslation(modal.DIV.querySelector('#savedSearchNameExistsLabel'), 'STR_WPT_SEARCH_EXISTS');
                        this._core.Helper.setElementTranslation(this._saveModalCancel.querySelector('#saveSearchCancelLabel'), 'STR_WPT_CANCEL');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalCancel, 'title', 'STR_WPT_CANCEL');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalCancel, 'aria-label', 'STR_WPT_CANCEL');
                        this._core.Helper.setElementTranslation(this._saveModalOK.querySelector('#saveSearchOKLabel'), 'STR_WPT_SAVE');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalOK, 'title', 'STR_WPT_SAVE');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalOK, 'aria-label', 'STR_WPT_SAVE');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalCloseSpan, 'title', 'STR_WPT_CLOSE');
                        this._core.Helper.setElementTranslationAttribute(this._saveModalCloseSpan, 'aria-label', 'STR_WPT_CLOSE');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#saveSearchProcessing'), 'STR_WPT_PROCESSING');
                        this._saveModalOK.addEventListener('click', this._saveOKClicked);
                        this._saveModalInput.addEventListener('input', this._enableDisableSaveOK);
                        this._saveModalInput.addEventListener('keydown', this._saveInputEnter);
                        this._saveModalClearText.addEventListener('click', this._clearInput);
                        this._core.showModal(this._currentModalSession);
                    }
                };
                this._revertSearch = () => {
                    this._log.info("TableSearchWidgetInstanceClass._revertSearch()");
                    let config = this._config;
                    this._core.Functions.hideElement(this._saveSearchSpan);
                    if (config.hasOwnProperty('Query')) {
                        this.updateSearch(config.Query);
                    }
                    else if (config.hasOwnProperty('FlexQuery')) {
                        this.updateSearchWithFlex(config.FlexQuery);
                    }
                };
                this._clearInput = () => {
                    this._log.info("TableSearchWidgetInstanceClass._clearInput()");
                    this._core.Functions.clearAndFocusInputElement(this._saveModalInput);
                    this._enableDisableSaveOK(null);
                };
                this._enableDisableSaveOK = (event) => {
                    this._log.info("TableSearchWidgetInstanceClass._enableDisableSaveOK()");
                    if (this._saveModalInput.value != "")
                        this._saveModalOK.disabled = false;
                    else
                        this._saveModalOK.disabled = true;
                };
                this._saveInputEnter = (event) => {
                    this._log.info("TableSearchWidgetInstanceClass._saveInputEnter()");
                    if (event.key === "Enter") {
                        event.preventDefault();
                        if (this._saveModalInput.value != "")
                            this._saveOKClicked(null);
                    }
                };
                this._saveOKClicked = (event) => {
                    this._log.info("TableSearchWidgetInstanceClass._saveOKClicked()");
                    // TODO: Prevent dublicate labels? Would need a list of existing searches better handled by the selection component
                    // Request creation of new envelope
                    let request = { SearchDefinition: this._currentSearchDef };
                    request.SearchDefinition.Label = this._saveModalInput.value;
                    this._core.Functions.showElement(this._saveModalLoader);
                    this._core.Loader.genericServiceCallWithData("/User.svc/rest/InsertSavedSearch", JSON.stringify(request), this._searchSaved, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._searchSaved = (response) => {
                    this._log.info("SimpleDocTableWidgetInstanceClass._searchSaved()");
                    let instance = this;
                    let modal = instance._core.getModal(instance._currentModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        instance._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_SEARCH_SAVED');
                    });
                    this._core.hideModal(this._currentModalSession);
                };
                this._fireDatasetEvent = (data) => {
                    this._log.info("TableSearchWidgetInstanceClass._fireDatasetEvent()");
                    if ((this._publishDataset == 'ALL') || ((this._publishDataset == 'INITIAL') && (data.ProducedBy == 'initial'))) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DATASET_PUBLISHED);
                        navEvent.ActivationID = 0;
                        navEvent.PrimaryContext = data;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("TableSearchWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                this._tableHeading = [];
                if (conf.hasOwnProperty('Heading') && conf.Heading.length > 0) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got heading config");
                    }
                    let length = conf.Heading.length;
                    for (let i = 0; i < length; i++) {
                        let heading = conf.Heading[i];
                        this._tableHeading[heading.Keyword] = heading;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("added heading: " + heading.Keyword + " => " + heading.Title);
                        }
                    }
                }
                this._specialColumns = [];
                if (conf.hasOwnProperty('SpecialColumns') && conf.SpecialColumns.length > 0) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got special columns config");
                    }
                    let length = conf.SpecialColumns.length;
                    for (let i = 0; i < length; i++) {
                        let specialColumn = JSON.parse(JSON.stringify(conf.SpecialColumns[i]));
                        this._specialColumns[specialColumn.Name] = specialColumn;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("added special column: " + specialColumn.Name);
                        }
                        if (specialColumn.hasOwnProperty('ValueOptions') && specialColumn.ValueOptions.length > 0) {
                            let length = specialColumn.ValueOptions.length;
                            let newValueOptions = [];
                            for (let j = 0; j < length; j++) {
                                let valueSetting = specialColumn.ValueOptions[j];
                                newValueOptions[valueSetting.Value] = valueSetting;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("added value setting for: " + valueSetting.Value);
                                }
                            }
                            specialColumn.ValueOptions = newValueOptions;
                        }
                    }
                }
                if (conf.hasOwnProperty('ActivateIntoSlots') && (conf.ActivateIntoSlots != null) && (conf.ActivateIntoSlots.length > 0))
                    this._activateIntoSlots = conf.ActivateIntoSlots;
                if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection == true))
                    this._registerDeselection = true;
            }
            activate(context) {
                this._log.info("TableSearchWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_DEFINITION:
                        if ((this._respondToPublishedQuery) && (context.PrimaryContext)) {
                            // Coerce to our expected type
                            let queryDef = context.PrimaryContext;
                            this.updateSearchWithFlex(queryDef, false);
                            if (this._core.serviceAvailable('savedsearches'))
                                this._core.Functions.showElement(this._saveSearchSpan);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_REQUESTED:
                        if (this._queryTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._queryTriggers.length; i++) {
                                let trigger = this._queryTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this.updateSearch(context.PrimaryContext);
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS:
                        if ((this._respondToPublishedHitList) && (context.PrimaryContext)) {
                            this._displayResult({ Documents: context.PrimaryContext });
                            if (context.AdditionalContext.hasOwnProperty('FlexSearch') && context.AdditionalContext.FlexSearch != null) {
                                this._currentSearchDef = context.AdditionalContext.FlexSearch;
                                if (this._core.serviceAvailable('savedsearches'))
                                    this._core.Functions.showElement(this._saveSearchSpan);
                            }
                            else {
                                this._currentSearchDef = null;
                                this._core.Functions.hideElement(this._saveSearchSpan);
                            }
                            this._showHideRevert(false);
                        }
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._doSearch();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        TableSearchWidgetInstanceClass.HtmlData = null;
        TableSearchWidgetInstanceClass.SaveSearchModalHtml = null;
        Widgets.TableSearchWidgetInstanceClass = TableSearchWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
